import { Stack, Typography } from "@mui/material";
import api from "../../../api/api";
import { useEffect, useState } from "react";
import ProfileCard from "./ProfileCard";
import { formatDate } from "../../../helpers/formatDate";
import { formatPhoneNumber } from "../../../helpers/formatNumber";

const ProfileOverview = () => {
  const [personalInformation, setPersonalInformation] = useState([]);
  const [educationInformation, setEducationInformation] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const response = await api.get("/profile/overview");

        setPersonalInformation([
          {
            label: "Name",
            value: response.data.name
          },
          {
            label: "Email",
            value: response.data.email
          },
          {
            label: "Phone",
            value: response.data.phone ? formatPhoneNumber(response.data.phone) : "N/A"
          },
          {
            label: "Mailing Address",
            value: response.data.mailingAddress
          }
        ]);
        setEducationInformation([
          {
            label: "Institution",
            value: response.data.institution
          },
          {
            label: "State",
            value: response.data.state
          },
          {
            label: "Degree",
            value: response.data.degree
          },
          {
            label: "Major",
            value: response.data.major
          },
          {
            label: "Graduation",
            value: formatDate(response.data.graduation, 'short')
          },
          {
            label: "GPA",
            value: response.data.gpa
          }
        ]);
      } catch (error) {
        console.error("Error fetching profile overview:", error);
      }
    })();
  }, []);

  return <Stack direction="column" spacing={2} width="100%" alignItems="flex-start">
    <h1>Profile Overview</h1>
    <Stack direction={{ xs: "column", lg: "row" }} spacing={4} width="100%">
      <ProfileCard title="Personal Information">
        {personalInformation.map((item, index) => (
          <Stack key={index} direction="row" spacing={2} width="100%" justifyContent="space-between" alignItems="center" sx={{ borderBottom: '1px solid #EDF0FC', paddingBottom: '10px'}}>
            <Typography variant="label2">{item.label}</Typography>
            <Typography variant="data">{item.value}</Typography>
          </Stack>
        ))}
      </ProfileCard>
      <ProfileCard title="Education">
        {educationInformation.map((item, index) => (
          <Stack key={index} direction="row" spacing={2} width="100%" justifyContent="space-between" alignItems="center" sx={{ borderBottom: '1px solid #EDF0FC', paddingBottom: '10px'}}>
            <Typography variant="label2">{item.label}</Typography>
            <Typography variant="data">{item.value}</Typography>
          </Stack>
        ))}
      </ProfileCard>
    </Stack>
  </Stack>;
};

export default ProfileOverview;